import { ensureMetaPixel } from '@/lib/metaPixel'

/** прямой Meta Pixel после согласия. Google Ads — только через GTM. */
export const applyAnalytic = () => {
  ensureMetaPixel()
}
